import { useEffect, useState } from 'react';
import type { Lot } from '../data/mockLots';

export type LotState = 'live' | 'scheduled' | 'closed';

export function deriveLotState(lot: Lot, nowMs: number = Date.now()): LotState {
  if (lot.startsAt && lot.startsAt > nowMs) return 'scheduled';
  if (lot.timerEndsAt <= nowMs) return 'closed';
  return 'live';
}

export function useLotState(lot: Lot, tickMs: number = 1000): LotState {
  const [state, setState] = useState<LotState>(() => deriveLotState(lot));

  useEffect(() => {
    setState(deriveLotState(lot));
    const id = window.setInterval(() => setState(deriveLotState(lot)), tickMs);
    return () => window.clearInterval(id);
  }, [lot, tickMs]);

  return state;
}
